import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//
import enLocales from './en.json';
import ptBrLocales from './pt-br.json'

// ----------------------------------------------------------------------

const LANGUAGE = "pt_br"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      pt_br: { translations: ptBrLocales },
    },
    lng: LANGUAGE,
    fallbackLng: LANGUAGE,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
